import React from "react";

import BorderBox from "@src/sharedComponents/BorderBox/BorderBox";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";

import styles from "./HouseholdProfile.module.css";

const ProfileSkeleton: React.FC = () => {
  return (
    <>
      {Array.from({ length: 5 }).map((_, index) => (
        <BorderBox
          variant="bold"
          className={styles.memberFormField}
          key={index}
        >
          <div className={styles.memberFormRow}>
            <div className={styles.memberNameField}>
              <Skeleton height={16} style={{ marginBottom: 8 }} />
              <Skeleton height={40} />
            </div>
            <div className={styles.memberRelationshipField}>
              <Skeleton height={16} style={{ marginBottom: 8 }} />
              <Skeleton height={40} />
            </div>
            <div className={styles.memberRelationshipField}>
              <Skeleton height={16} style={{ marginBottom: 8 }} />
              <Skeleton height={40} />
            </div>
          </div>
        </BorderBox>
      ))}
    </>
  );
};

export default ProfileSkeleton;
